import React, { PropsWithChildren, useContext } from 'react';
import type { IUouChatMessages } from '@wix/ai-scheduling-assistant-localization';

export interface IUouLanguageContext {
  language?: IUouChatMessages<JSX.Element>;
}

export const UouLanguageContext = React.createContext<IUouLanguageContext>({});

export const UouLanguageContextProvider: React.FC<PropsWithChildren<Required<IUouLanguageContext>>> = ({ language, children }) => {
  return <UouLanguageContext.Provider value={{ language }}>{children}</UouLanguageContext.Provider>;
};

export function useUouLanguageContext() {
  const context = useContext(UouLanguageContext);

  return context;
}
